import { DataAccessTypeEnum } from "./features/ShareContact";
import { Mimshak } from "./mislaka_xml_models";

export enum ReportType {
  HOLDINGS_INTERFACE = 1,      // ממשק אחזקות
  PRE_ADVICE_INTERFACE = 2,    // ממשק טרום ייעוץ
  BOTH_INTERFACES = 3          // ממשק אחזקות + טרום ייעוץ
}

export enum ReportOrigin {
  AUTOMATIC = 1,  // דו"ח שנוצר אוטומטית
  MANUAL = 2      // דו"ח שהוזן ידנית
}

export interface MimshakData {
  id: number;
    contact_id: number;
    handler_code: string;
    reported_period: string;
    product_type: number; // שדה חדש
    adjusted_product_type?: number | null; // שדה חדש, אופציונלי
    funds_sum: number; // שדה חדש
    data?:Mimshak; // JSON data

    policy_number: string; // שדה חדש
    deposit_fee: number; // שדה חדש
    saving_fee: number; // שדה חדש
    deposit_amount: number; // שדה חדש
    withdrawal_amount: number; // שדה חדש
    transfer_out?: number | null;
    transfer_in?: number | null;
    transfer_out_to?: string | null;
    agent_appointment_date?: string | null;
    agent_code?: string | null; // קוד סוכן, אופציונלי
    new_policy: boolean;
    data_access_type?: DataAccessTypeEnum;
    fund_ids?: number[];
    report_origin?:number;
    report_type?: number; // סוג הדו"ח, אופציונלי
    payment_frequency?: number | null; // תדירות תשלום
    recurrent_deposit?: number | null; // הפקדה קבועה
    join_date?: string | null; // תאריך הצטרפות לפוליסה
    p_join_date?: string | null; // תאריך הצטרפות למוצר (product_join_date) – מגיע רק מהטבלה mimshak_data
  }

  export const defaultEmptyMimshakData = (userId: number): Omit<MimshakData, 'id'> => ({
    contact_id: userId,
    handler_code: "",
    reported_period: "",
    product_type: -1,
    adjusted_product_type: null, // אופציונלי
    policy_number: "",
    deposit_fee: 0,
    saving_fee: 0,
    deposit_amount: 0,
    withdrawal_amount: 0,
    transfer_out: null,
    transfer_in: null,
    transfer_out_to: null,
    agent_appointment_date: null,
    new_policy: false,
    funds_sum: 0,
    data_access_type: DataAccessTypeEnum.FULL,
    data: undefined,
    fund_ids: undefined,
    payment_frequency: null,
    recurrent_deposit: null,
    join_date: null,
    p_join_date: null
  });
